import type { PropsWithChildren } from 'react';

import { createContext, useContext, useMemo } from 'react';

import type { RovingFocusItemProps } from '~/utilities/hooks/useRovingFocus';

interface CarouselContextValue {
  setTileWidth: (width: number) => void;
  getItemProps: (index: number) => RovingFocusItemProps;
}

const CarouselContext = createContext<CarouselContextValue | null>(null);

export const CarouselProvider = ({
  children,
  setTileWidth,
  getItemProps,
}: PropsWithChildren<CarouselContextValue>) => {
  const value = useMemo(
    () => ({
      setTileWidth,
      getItemProps,
    }),
    [setTileWidth, getItemProps]
  );

  return <CarouselContext.Provider value={value}>{children}</CarouselContext.Provider>;
};

export const useCarouselContext = (): CarouselContextValue => {
  const context = useContext(CarouselContext);

  if (!context) {
    throw new Error('useCarouselContext must be used within a CarouselProvider');
  }

  return context;
};
